// extracted by mini-css-extract-plugin
export default {"small":"NumberInput_small__UNM-W","medium":"NumberInput_medium__B8vt9","hasError":"NumberInput_hasError__RrVh1","fullWidth":"NumberInput_fullWidth__fpUop"};